import {authHeader, isTokenExpired} from "../helpers";

export const myClassesServices = {
  // class security manager
  getGroups,
  getMyGroups,
  getGroupById,
  createGroup,
  updateGroup,

  // classManagement
  getGroupsWithStats,
  getExpariencesByGroup,
  getGroupMembersStatistics,
  getGroupMembersStatisticsById,
  getAllStatisticsForMyGroups,
  getTimeSpentForMyGroups
};

function getGroups(isAdmin, groupIds) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  let queryGroupIds = "";
  if (groupIds.length > 0) {
    groupIds.forEach((id, index) => {
      if (index === 0) queryGroupIds += `?groupIds=${id}&`;
      else if (index === groupIds.length - 1) queryGroupIds += `groupIds=${id}`;
      else queryGroupIds += `groupIds=${id}&`;
    });
  }
  const url = isAdmin
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/groups`
    : `${process.env.REACT_APP_GATEWAY_URL}/groups${queryGroupIds}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getMyGroups() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/groups/me`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getGroupById(id, isAdmin) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}${
    isAdmin ? "/admin" : ""
  }/groups/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createGroup(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${process.env.REACT_APP_GATEWAY_URL}/groups`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json(); // replace the map wuth exparienceGame
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}

function updateGroup(data, id) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/groups/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

//// class Management

function getGroupsWithStats() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  // management general en tant que user
  const url = `${process.env.REACT_APP_GATEWAY_URL}/dm/me/groups`;

  // renvoie les stats des membres des classes dont tu es propriétaire pour l'expérience dont tu es admin
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getExpariencesByGroup(groupId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  // route pour le management general
  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/dm/groups/${groupId}/expariences`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getGroupMembersStatistics(isAdmin) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}${
    isAdmin ? "/admin" : ""
  }/groups/statistics`;

  // like /dm/me/groups but entry point is nested (do not send experience data)
  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getGroupMembersStatisticsById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  // MANAGE LA 404 EN CAS D'ERREUR

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/groups/${id}/statistics`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getAllStatisticsForMyGroups(id, page, groupId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = `${process.env.REACT_APP_GATEWAY_URL}/dm/${id}/groups/statistics?page=${page}${groupId ? `&groupId=${groupId}` : ''}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getTimeSpentForMyGroups(id, groupId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = `${process.env.REACT_APP_GATEWAY_URL}/dm/${id}/groups/statistics/time-spent${groupId ? `?groupId=${groupId}` : ''}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
